import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SaleItem } from '../../../../data/sale-item';
import { QBClass } from '../../../../data/qb-class';
import { QBServ } from '../../../../data/qb-serv';
import { SaleListChooserComponent } from './sale-list-chooser/sale-list-chooser.component';

interface LineObj {
    name: string;
    value: string;
}

@Component({
    selector: 'app-mobile-sale-editor',
    templateUrl: './mobile-sale-editor.component.html',
    styleUrls: ['./mobile-sale-editor.component.scss']
})
export class MobileSaleEditorComponent implements OnInit {
    tempService: LineObj;
    tempQt: number;
    tempRate: number;
    tempClass: LineObj;
    tempDesc: string;

    classes: QBClass[]
    servs: QBServ[]


    constructor(
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: {
            item: SaleItem,
            baseQbServClasses: [QBClass[], QBServ[]]
        },
        protected dialogRef: MatDialogRef<MobileSaleEditorComponent>
    ) {
        this.classes = this.data.baseQbServClasses[0]
        this.servs = this.data.baseQbServClasses[1]

        if (this.data.item.salesItemLineDetail && this.data.item.salesItemLineDetail.itemRef) {
            this.tempService = {
                name: this.data.item.salesItemLineDetail.itemRef.name,
                value: this.data.item.salesItemLineDetail.itemRef.value
            }
        }

        if (this.data.item.salesItemLineDetail && this.data.item.salesItemLineDetail.classRef) {
            this.tempClass = {
                name: this.data.item.salesItemLineDetail.classRef.name,
                value: this.data.item.salesItemLineDetail.classRef.value
            }
        }

        this.tempQt = this.data.item.salesItemLineDetail.qty
        this.tempRate = this.data.item.salesItemLineDetail.unitPrice

        this.tempDesc = this.data.item.description
    }

    ngOnInit(): void {

    }

    cancelButton() {
        this.dialogRef.close(['null', null])
    }

    saveButton() {
        this.data.item.salesItemLineDetail.itemRef.name = this.tempService.name
        this.data.item.salesItemLineDetail.itemRef.value = this.tempService.value

        this.data.item.salesItemLineDetail.classRef.name = this.tempClass.name
        this.data.item.salesItemLineDetail.classRef.value = this.tempClass.value

        this.data.item.salesItemLineDetail.qty = this.tempQt
        this.data.item.salesItemLineDetail.unitPrice = this.tempRate
        this.data.item.amount = this.tempQt * this.tempRate;

        this.data.item.description = this.tempDesc

        this.dialogRef.close(['Save', this.data.item])
    }

    selectAll(inputik: HTMLInputElement) {
        inputik.setSelectionRange(0, inputik.value.length)
    }

    openChooserClasses() {
        const dialogRef = this.dialog.open(SaleListChooserComponent, {
            data: this.classes,
            panelClass: ['sale-list-modal-dialog', 'FULLSCREEN-DIALOG'],
            disableClose: false
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const founded = this.classes.find(clas => clas.id === (result as QBClass).id)
                this.tempClass = {
                    name: founded.fullyQualifiedName,
                    value: founded.id
                }
            }
        });
    }

    openChooserServs() {
        const dialogRef = this.dialog.open(SaleListChooserComponent, {
            data: this.servs,
            panelClass: ['sale-list-modal-dialog', 'FULLSCREEN-DIALOG'],
            disableClose: false
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const founded = this.servs.find(serv => serv.id === (result as QBServ).id)
                this.tempService = {
                    name: founded.fullyQualifiedName,
                    value: founded.id
                }
            }
        });
    }

}
